import { motion } from 'framer-motion';
import { Answer, CreateAnswerDto } from '@/types/workerInfo.types';
import { EducationInput } from '../inputs/EducationInput';
import { DocumentInput } from '../inputs/DocumentInput';
import { CategoryHeader } from '../common/CategoryHeader';
import { colors, spacing } from '@/theme';

interface EducationCategoryProps {
  answers: Answer[];
  progress: number;
  onUpdateAnswer: (questionId: string, data: Partial<CreateAnswerDto>) => Promise<void>;
  saving: boolean;
}

export function EducationCategory({ answers, progress, onUpdateAnswer, saving }: EducationCategoryProps) {

  const renderInput = (answer: Answer) => {
    const { question, questionId } = answer;
    const commonProps = {
      key: questionId,
      answer,
      onBlur: async (value: any) => {
        try {
          await onUpdateAnswer(questionId, value);
        } catch (error) {
          console.error('Error updating:', error);
        }
      },
      disabled: saving,
    };

    switch (question.type) {
      case 'education':
        return <EducationInput {...commonProps} />;
      case 'document':
        return <DocumentInput {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}>
      <CategoryHeader
        icon="🎓"
        title="Formacion academica"
        description="Tus estudios, certificados y titulaciones."
        progress={progress}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[3] }}>
        {answers.map((answer, index) => (
          <motion.div
            key={answer.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03 }}
            style={{
              padding: spacing[4],
              borderRadius: 16,
              border: `1px solid ${colors.gray[100]}`,
              backgroundColor: colors.white,
            }}
          >
            {renderInput(answer)}
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
